import AccardionOrderDataSidebar from './AccardionOrderDataSidebar';

export default AccardionOrderDataSidebar;
